// extracted by mini-css-extract-plugin
export default {"hidden_input":"ImageUpload_hidden_input__OtH53","upload_link":"ImageUpload_upload_link__VH1F3","image_form":"ImageUpload_image_form__MFjE8"};